import React from 'react'
import { Box, Text } from '@usap/uicomponents'
import { Heading4 } from '../../../common/heading'
import MultiItemBox from './MultiItemBox'
import { Container, VerticalLine, OrderInfo, InfoText, ErrorText } from "./style/RMAReturnOrderInfoWMO.css"

const RMAReturnOrderInfoWMO = ({
  merchantOrderId,
  errorSteps,
  setItemImage,
  showTabs,
  selectedPartIndx,
  isDesktop,
  formatedDate,
  enabled,
  multipleItemsPresent
}) => {

  return (
    <>
      <Container>
        {enabled && (
          <Box width="100%" alignContent="center" alignSelf="center">
            <Text
              size={isDesktop ? "24px" : "20px"}
              color="dark-2"
              margin={{ bottom: '16px' }}
              weight={500}
            >Select an Item to Return</Text>
          </Box>
        )}
        <OrderInfo>
          {
            multipleItemsPresent ?
              <>
                <InfoText>
                  Order #:{' '}
                  <span>{merchantOrderId}</span>
                </InfoText>
                <VerticalLine>|</VerticalLine>
                <InfoText>
                  Date Purchased:{' '}
                  <span>{formatedDate}</span>
                </InfoText>
              </>
              :
              <>
                <InfoText>
                  Order Date:{' '}
                  <span>{formatedDate}</span>
                </InfoText>
                <VerticalLine>|</VerticalLine>
                <InfoText>
                  Order #:{' '}
                  <span>{merchantOrderId}</span>
                </InfoText>
              </>
          }

        </OrderInfo>
        <Box id="error-ReturnPart" width="100%">
          <ErrorText>
            {errorSteps.errorReturnPart}
          </ErrorText>
        </Box>
      </Container>
      {showTabs && (
        <Box id="multiItemBox">
          <MultiItemBox
            setItemImage={setItemImage}
            activeCount={selectedPartIndx}
            isDesktop={isDesktop}
          />
        </Box>
      )}
    </>
  )
}

export default RMAReturnOrderInfoWMO
